module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "id": "studentManage",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'addressForm'],
      "title": _vm.$t('MANAGESTUDENT'),
      "data": {
        student: this.student,
        guardians: this.guardians,
        address: this.address
      }
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.cardHeight + 'px'
    })
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.student,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('wi-upload', {
    attrs: {
      "person": _vm.student
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GENDER'),
      "prop": "Gender",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.student.Gender),
      callback: function($$v) {
        _vm.$set(_vm.student, "Gender", $$v)
      },
      expression: "student.Gender"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Male"
    }
  }, [_vm._v(_vm._s(_vm.$t('MALE')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Female"
    }
  }, [_vm._v(_vm._s(_vm.$t('FEMALE')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME'),
      "prop": "FirstName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.FirstName_EN),
      callback: function($$v) {
        _vm.$set(_vm.student, "FirstName_EN", $$v)
      },
      expression: "student.FirstName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FIRSTNAME(ARABIC)'),
      "prop": "FirstName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.FirstName_AR),
      callback: function($$v) {
        _vm.$set(_vm.student, "FirstName_AR", $$v)
      },
      expression: "student.FirstName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME'),
      "prop": "MiddleName",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.MiddleName),
      callback: function($$v) {
        _vm.$set(_vm.student, "MiddleName", $$v)
      },
      expression: "student.MiddleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FATHERNAME(ARABIC)'),
      "prop": "MiddleName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.MiddleName_AR),
      callback: function($$v) {
        _vm.$set(_vm.student, "MiddleName_AR", $$v)
      },
      expression: "student.MiddleName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME'),
      "prop": "LastName_EN",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.LastName_EN),
      callback: function($$v) {
        _vm.$set(_vm.student, "LastName_EN", $$v)
      },
      expression: "student.LastName_EN"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('LASTNAME(ARABIC)'),
      "prop": "LastName_AR",
      "rules": [{
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 64,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 64
        }),
        trigger: 'blur'
      }, {
        validator: _vm.nameValidation,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.LastName_AR),
      callback: function($$v) {
        _vm.$set(_vm.student, "LastName_AR", $$v)
      },
      expression: "student.LastName_AR"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DATEOFBIRTH'),
      "prop": "DOB",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "picker-options": _vm.pickerOption,
      "default-value": _vm.defaultDate,
      "format": _vm.date_format
    },
    model: {
      value: (_vm.student.DOB),
      callback: function($$v) {
        _vm.$set(_vm.student, "DOB", $$v)
      },
      expression: "student.DOB"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "prop": "Nationality",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTNATIONALITY'),
      "filterable": ""
    },
    model: {
      value: (_vm.student.Nationality),
      callback: function($$v) {
        _vm.$set(_vm.student, "Nationality", $$v)
      },
      expression: "student.Nationality"
    }
  }, _vm._l((_vm.$countries), function(value, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": value,
        "value": key
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GRADE'),
      "prop": "Grade",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "value-key": "GradeID",
      "placeholder": _vm.$t('SELECTGRADE')
    },
    on: {
      "change": _vm.setGrade
    },
    model: {
      value: (_vm.Grade),
      callback: function($$v) {
        _vm.Grade = $$v
      },
      expression: "Grade"
    }
  }, _vm._l((_vm.grades), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CLASS'),
      "prop": "Class",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.student.Grade == null,
      "placeholder": _vm.$t('SELECTCLASS')
    },
    model: {
      value: (_vm.student.Class),
      callback: function($$v) {
        _vm.$set(_vm.student, "Class", $$v)
      },
      expression: "student.Class"
    }
  }, _vm._l((_vm.Grade.Classes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STUDENTSCHOOLID'),
      "prop": "ExternalStudentID",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        validate: true,
        message: _vm.$t('STUDENTSCHOOLID') + ' ' + _vm.$t('ALREADYEXISTED')
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 16,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 16
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.student.ExternalStudentID),
      callback: function($$v) {
        _vm.$set(_vm.student, "ExternalStudentID", $$v)
      },
      expression: "student.ExternalStudentID"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ATTENDANCETAGID')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('CLICKONSCAN')
    },
    model: {
      value: (_vm.student.AssignedTagID),
      callback: function($$v) {
        _vm.$set(_vm.student, "AssignedTagID", $$v)
      },
      expression: "student.AssignedTagID"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showScanModal(_vm.student)
      }
    },
    slot: "append"
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" " + _vm._s(_vm.$t('SCAN')))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.getTabData
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ADDRESS')
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "addressBar",
    style: ({
      height: _vm.cardHeight - 42 + 'px'
    })
  }, [_c('el-form', {
    ref: "addressForm",
    attrs: {
      "model": _vm.address,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticClass: "googleMapV"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "200px"
    },
    attrs: {
      "id": "student-gmap"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "el-input__inner",
    staticStyle: {
      "padding": "25px 10px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('SEARCHADDRESS'),
      "id": "location",
      "autocomplete": "off"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('COORDINATES'),
      "prop": "address",
      "rules": {
        validator: _vm.valCoordinates,
        required: true,
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": function($event) {
        _vm.positionSet = false
      }
    },
    model: {
      value: (_vm.address.Lat),
      callback: function($$v) {
        _vm.$set(_vm.address, "Lat", _vm._n($$v))
      },
      expression: "address.Lat"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('LAT')))])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "change": function($event) {
        _vm.positionSet = false
      }
    },
    model: {
      value: (_vm.address.Lng),
      callback: function($$v) {
        _vm.$set(_vm.address, "Lng", _vm._n($$v))
      },
      expression: "address.Lng"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$t('LNG')))])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.positionSet
    },
    on: {
      "click": function($event) {
        _vm.setPosition()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('HOUSENUMBER'),
      "prop": "HouseNumber",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.HouseNumber),
      callback: function($$v) {
        _vm.$set(_vm.address, "HouseNumber", $$v)
      },
      expression: "address.HouseNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STREETADDRESS')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.Address),
      callback: function($$v) {
        _vm.$set(_vm.address, "Address", $$v)
      },
      expression: "address.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('AREA')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.Area),
      callback: function($$v) {
        _vm.$set(_vm.address, "Area", $$v)
      },
      expression: "address.Area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ZONE')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.Zone),
      callback: function($$v) {
        _vm.$set(_vm.address, "Zone", $$v)
      },
      expression: "address.Zone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SECTOR')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.Sector),
      callback: function($$v) {
        _vm.$set(_vm.address, "Sector", $$v)
      },
      expression: "address.Sector"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('CITY'),
      "prop": "City",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 34,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 34
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.City),
      callback: function($$v) {
        _vm.$set(_vm.address, "City", $$v)
      },
      expression: "address.City"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STATE'),
      "prop": "State",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        min: 2,
        message: _vm.$t('MUSTBEATLEASTCHARACTERSINLENGTH', {
          len: 2
        }),
        trigger: 'blur'
      }, {
        max: 34,
        message: _vm.$t('CANNOTEXCEEDCHARACTERSINLENGTH', {
          len: 34
        }),
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.State),
      callback: function($$v) {
        _vm.$set(_vm.address, "State", $$v)
      },
      expression: "address.State"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('ZIPCODE'),
      "prop": "ZipCode",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.address.ZipCode),
      callback: function($$v) {
        _vm.$set(_vm.address, "ZipCode", $$v)
      },
      expression: "address.ZipCode"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('GUARDIANS')
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "0"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('SEARCHGUARDIANNAME'),
      "icon": "search"
    },
    on: {
      "select": _vm.addGuardian
    },
    model: {
      value: (_vm.guardian),
      callback: function($$v) {
        _vm.guardian = $$v
      },
      expression: "guardian"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listGuardians,
      "highlight-current-row": "",
      "height": _vm.cardHeight - 118,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "50px",
            "float": "left"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'guardian'),
            "alt": ""
          }
        }), _vm._v("\n                     " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        }) + _vm.$t('')) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('RELATION'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.$t(scope.row.Relation)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('PRIMARYCONTACT'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.checkPrimary(scope.row)
            }
          }
        }, [_c('span', {
          staticClass: "el-radio__input",
          class: {
            'is-checked': scope.row.IsPrimary
          }
        }, [_c('span', {
          staticClass: "el-radio__inner"
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.length > 1 && !scope.row.IsMain),
            expression: "scope.row.length>1 && !scope.row.IsMain"
          }],
          staticClass: "fa fa-2x",
          class: scope.row.deleted ? 'fa-undo' : 'fa-remove',
          on: {
            "click": function($event) {
              scope.row.deleted = !scope.row.deleted
            }
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (_vm.student.StudentID != null) ? _c('el-tab-pane', {
    attrs: {
      "name": "route",
      "label": _vm.$t('ROUTES')
    }
  }, [_c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingRoutes),
      expression: "loadingRoutes"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.routes,
      "highlight-current-row": "",
      "height": _vm.cardHeight - 118,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    staticClass: "left",
    attrs: {
      "label": _vm.$t('NAME'),
      "show-overflow-tooltip": "",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "display": "block",
            "text-align": "center"
          },
          style: ('background-color:' + scope.row.RouteColor)
        }, [_c('el-button', {
          staticStyle: {
            "color": "#fff",
            "padding": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.TourName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BusNumber",
      "label": _vm.$t('BUSNUMBER'),
      "min-width": "100",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DRIVER'),
      "min-width": "130",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.DriverPhoto, 'driver'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.DriverFullName_EN,
          NameAR: scope.row.DriverFullName_AR
        })) + "            \n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('SUPERVISOR'),
      "min-width": "130",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.MonitorPhoto, 'supervisor'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.MonitorFullName_EN,
          NameAR: scope.row.MonitorFullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "align": "right",
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITROUTE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingActivities),
      expression: "loadingActivities"
    }],
    attrs: {
      "name": "activity",
      "label": _vm.$t('ACTIVITIES'),
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "value-key": "ID",
      "placeholder": _vm.$t('SELECTACTIVITY')
    },
    model: {
      value: (_vm.Activity),
      callback: function($$v) {
        _vm.Activity = $$v
      },
      expression: "Activity"
    }
  }, _vm._l((_vm.activityList), function(item, index) {
    return (!_vm.activities[item.ID]) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.Activity == null || _vm.savingActivity,
      "value-key": "ID"
    },
    on: {
      "click": _vm.addActivity
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.savingActivity),
      expression: "!savingActivity"
    }],
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.savingActivity ? _vm.$t('SAVING') : _vm.$t('ADDACTIVITY')) + "\n  ")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listActivities,
      "height": _vm.cardHeight - 118
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('ACTIVITYNAME'),
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEACTIVITY'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteActivity(props.row.ActivityID)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-remove"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ABSENCES')
    }
  }, [_vm._v(_vm._s(_vm.$t('ABSENCES')))]) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('MESSAGES')
    }
  }, [_vm._v(_vm._s(_vm.$t('MESSAGES')))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tag-dialog', {
    attrs: {
      "callScan": _vm.callScan,
      "student": _vm.student
    },
    on: {
      "update:callScan": function($event) {
        _vm.callScan = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bc3e0df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/school/StudentManage.vue
// module id = 587
// module chunks = 1